<template>
  <table v-if="treeData.name" class="puppy-tree">
    <tr>
      <td
        :colspan="treeData.children ? treeData.children.length * 2 : 1"
        :class="{
          parentLevel: treeData.children,
          extend: treeData.children && treeData.extend,
        }"
      >
        <center>
          <div
            :class="{ node: true, hasMate: treeData.mate }"
            style="display: flex; justify-content: center"
            :style="{
              width:
                treeData.mate &&
                (treeData.mate.length > 1
                  ? treeData.mate.length * 145 + 'px'
                  : treeData.mate.length == 1
                  ? '224px'
                  : '100px'),
            }"
          >
            <div v-if="treeData.way_point_node" class="crown-man">
              <!-- <i class="icofont-crown"></i> -->
            </div>
            <div class="person" @click="$emit('click-node', { data: treeData, isMate: false })">
              <div class="avat" :class="{ 'avat-exit': treeData.way_point_node }">
                <img
                  :src="'data:image/png;base64, ' + treeData.image_url"
                  v-if="treeData.image_url"
                  alt="Bloodline User"
                />
                <img src="../assets/dp.png" v-else alt="Bloodline User" />
              </div>
              <div class="name">{{ treeData.name }}</div>
              <i
                class="icofont-long-arrow-left object"
                v-if="treeData.way_point_node"
              ></i>
            </div>
            <div v-if="treeData.mate" style="display: flex; margin-left: 20px">
              <div
                class="person mate"
                @click="
                  $emit('click-node', {
                    data: treeData.mate[index],
                    isMate: true,
                  })
                "
                v-for="(mate, index) in treeData.mate"
                :key="index"
              >
                <div class="avat green-circle">
                  <img
                    :src="'data:image/png;base64, ' + mate.image_url"
                    v-if="mate.image_url"
                    alt="Bloodline User"
                  />
                  <img src="../assets/dp.png" v-else alt="Bloodline User" />
                </div>
                <div class="name">{{ mate.name }}</div>
              </div>
            </div>
          </div>
          <div class="extend_handle" v-if="treeData.children" @click="toggleExtend(treeData)"></div>
        </center>
      </td>
    </tr>
    <tr v-if="treeData.children && treeData.extend">
      <td
        v-for="(children, index) in treeData.children"
        :key="index"
        colspan="2"
        class="childLevel"
      >
        <center>
          <TreeChart :json="children" @click-node="$emit('click-node', $event)" />
        </center>
      </td>
    </tr>
  </table>
</template>

<script>
var images1 = {};
export default {
  name: "TreeChart",
  components: {},
  props: ["json", "images"],

  data() {
    return {
      treeData: {},
      num: 1,
      img: this.images
    };
  },
  watch: {
    json: {
      handler: function(Props) {
        let extendKey = jsonData => {
          if (images1.all) {
            jsonData.image_url = images1.all[jsonData.id];
            if (jsonData.mate) {
              for (let mate of jsonData.mate) {
                mate.image_url = images1.all[mate.id];
              }
            }
          }
          jsonData.extend =
            jsonData.extend === void 0 ? true : !!jsonData.extend;
          if (Array.isArray(jsonData.children)) {
            jsonData.children.forEach(c => {
              extendKey(c);
            });
          }
          return jsonData;
        };
        if (Props) {
          if (!images1.all) {
            images1.all = this.images;
          }
          this.treeData = extendKey(Props);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toggleExtend: function(treeData) {
      treeData.extend = !treeData.extend;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.icofont-long-arrow-left {
  color: indianred !important;
  font-size: 40px;
  top: -89px;
  margin-left: -150px;
}
.object {
  animation: MoveUpDown 1s linear infinite;
  position: relative;
  color: rgb(132, 129, 129);
}
@keyframes MoveUpDown {
  0%,
  100% {
    left: -5px;
  }
  50% {
    left: 0px;
  }
}
.avat-exit {
  width: 5em !important;
  height: 5em !important;
  -moz-box-shadow: 0px 2px 35px -1px rgba(224, 103, 103, 1) !important;
  -webkit-box-shadow: 0px 2px 35px -5px rgba(224, 103, 103, 1) !important;
  -moz-box-shadow: 0px 2px 35px -5px rgba(224, 103, 103, 1) !important;
  box-shadow: 0px 2px 35px -5px rgba(224, 103, 103, 1) !important;
}
.crown-man {
  transform: rotate(-50deg);
  margin-left: -88px;
  font-size: 40px;
  position: absolute;
  z-index: 10;
  margin-top: -30px;
  color: indianred;
}
.red-circle {
  border: 3px solid red !important;
}
.green-circle {
  border: 2px solid indianred !important;
}
table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
td {
  position: relative;
  vertical-align: top;
  padding: 0 0 50px 0;
  text-align: center;
}

.extend_handle {
  position: absolute;
  left: 50%;
  bottom: 20px;
  width: 20px;
  height: 20px;
  margin-left: 5px;
  /* padding: 0 10px 3px 5px; */
  transform: translate3d(-15px, 0, 0);
  cursor: pointer;
}
.extend_handle:before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 2px solid;
  border-color: rgba(79, 142, 247, 0.6) rgba(79, 142, 247, 0.6) transparent transparent;
  transform: rotateZ(135deg);
  transform-origin: 50% 50% 0;
  transition: all ease 300ms;
  filter: drop-shadow(0 0 4px rgba(79, 142, 247, 0.8));
}
.extend_handle:hover:before {
  border-color: #a78bfa #a78bfa transparent transparent;
  filter: drop-shadow(0 0 8px rgba(167, 139, 250, 0.9));
}
.extend .extend_handle:before {
  transform: rotateZ(-45deg);
}

.extend::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 15px;
  height: 15px;
  border-left: 2px solid rgba(79, 142, 247, 0.6);
  transform: translate3d(-1px, 0, 0);
  filter: drop-shadow(0 0 4px rgba(79, 142, 247, 0.8));
}

.childLevel::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 100%;
  height: 15px;
  border-left: 2px solid rgba(79, 142, 247, 0.6);
  transform: translate3d(-1px, 0, 0);
  filter: drop-shadow(0 0 4px rgba(79, 142, 247, 0.8));
}
.childLevel::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: -15px;
  border-top: 2px solid rgba(79, 142, 247, 0.6);
  filter: drop-shadow(0 0 4px rgba(79, 142, 247, 0.8));
}
.childLevel:first-child:before,
.childLevel:last-child:before {
  display: none;
}
.childLevel:first-child:after {
  left: 50%;
  height: 15px;
  border: 2px solid;
  border-color: rgba(79, 142, 247, 0.6) transparent transparent rgba(79, 142, 247, 0.6);
  border-radius: 12px 0 0 0;
  transform: translate3d(1px, 0, 0);
}
.childLevel:last-child:after {
  right: 50%;
  height: 15px;
  border: 2px solid;
  border-color: rgba(79, 142, 247, 0.6) rgba(79, 142, 247, 0.6) transparent transparent;
  border-radius: 0 12px 0 0;
  transform: translate3d(-1px, 0, 0);
}
.childLevel:first-child.childLevel:last-child::after {
  left: auto;
  border-radius: 0;
  border-color: transparent rgba(79, 142, 247, 0.6) transparent transparent;
  transform: translate3d(1px, 0, 0);
}

.node {
  position: relative;
  display: inline-block;
  width: 13em;
  box-sizing: border-box;
  text-align: center;
}
.node .person {
  position: relative;
  display: inline-block;
  z-index: 2;
  width: 6em;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.node .person:hover {
  transform: translateY(-10px) scale(1.05);
  z-index: 10;
}
.node .mate .avat {
  border-radius: 50%;
}

.node .person .avat {
  display: block;
  width: 4em;
  height: 4em;
  margin: auto;
  overflow: hidden;
  background: rgba(15, 17, 35, 0.8);
  border: 2px solid #a78bfa;
  box-sizing: border-box;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(167, 139, 250, 0.5);
  transition: all 0.4s ease;
}
.node .person:hover .avat {
  border-color: #4f8ef7;
  box-shadow: 0 0 30px rgba(79, 142, 247, 0.8), inset 0 0 10px rgba(79, 142, 247, 0.5);
}
.node .person .avat img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.node .person .name {
  height: 2em;
  line-height: 2em;
  overflow: hidden;
  width: 100%;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}
.node.hasMate::after {
  content: "";
  position: absolute;
  left: 2em;
  right: 2em;
  top: 2em;
  border-top: 2px solid rgba(79, 142, 247, 0.6);
  z-index: 1;
  filter: drop-shadow(0 0 4px rgba(79, 142, 247, 0.8));
}
.node.hasMate .person {
  margin-left: 1em;
}

.landscape {
  transform: translate(-100%, 0) rotate(-90deg);
  transform-origin: 100% 0;
}
.landscape .node {
  text-align: left;
  height: 8em;
  width: 8em;
}
.landscape .person {
  position: relative;
  transform: rotate(90deg);
  padding-left: 4.5em;
  height: 4em;
  top: 4em;
  left: -1em;
}
.landscape .person .avat {
  position: absolute;
  left: 0;
}
.landscape .person .name {
  height: 4em;
  line-height: 4em;
}
.landscape .hasMate {
  position: relative;
}
.landscape .hasMate .person {
  position: absolute;
}
.landscape .hasMate .person:first-child {
  left: auto;
  right: -4em;
}
.landscape .hasMate .person:last-child {
  left: -4em;
  margin-left: 0;
}
</style>
